export function deleteObjectProperties<U, K extends keyof U>(object: U, deletingProperties: K[]) {
  const newObject = { ...object };

  Object.keys(newObject)
    .filter((key: keyof object) => deletingProperties.includes(key))
    .forEach((key: keyof object) => delete newObject[key]);

  return newObject;
}
